"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import API from "@ym-framework/api-utils";
import BatchOperate from "@/views/managements/teammanager/components/batchComponents/BatchOperate.vue";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v1/webpage-access-rules")
);
let AccessRules = class extends Vue {
  constructor() {
    super(...arguments);
    this.rule_is_empty = false;
    this.rule_search = "";
    this.empty_image = emptyImage;
    this.gridController = _gridController;
    this.selectDatas = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.filter = null;
      yield this.gridController.search();
    });
  }
  showRightDrawer() {
  }
  openRulesGuide() {
    window.open("https://www.kuajingvs.com/help2/24939", "__blank");
  }
  selectItems(items) {
    this.selectDatas = items;
  }
  addRules() {
    this.$router.push("/add_rules");
  }
  clearBatch() {
    this.selectDatas = [];
    this._grid_table.clearSelection();
  }
  editRules(data) {
    this.$router.push({ name: "AddRules", query: { "id": data.id } });
  }
  searchGrids() {
    return __async(this, null, function* () {
      try {
        if (this.rule_search === "" || this.rule_search === null) {
          this.gridController.query.filter = null;
          yield this.gridController.search();
        } else {
          let search = `name=='%${this.rule_search}%',description=='%${this.rule_search}%'`;
          this.gridController.query.filter = search;
          yield this.gridController.search();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "off":
          yield this.handleOffRule(command.data);
          break;
        case "on":
          yield this.handleOpenRule(command.data);
          break;
        case "delete":
          yield this.deleteRules(command.data);
          break;
        case "copy":
          yield this.copyRules(command.data);
          break;
      }
    });
  }
  copyRules(item) {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v1/webpage-access-rules-copy/${item.id}`);
        this.$message.success(this.$t("safemanager.access_rules.copy_rules_success"));
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  deleteRules(item) {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("safemanager.access_rules.delete_item_tips", {
            name: item.name
          }),
          this.$t("vdcontainer.hint"),
          {
            confirmButtonText: this.$t("vdcontainer.determine"),
            cancelButtonText: this.$t("vdcontainer.cancel"),
            type: "warning"
          }
        );
        yield API.delete(
          `api://base.auth/api/v1/webpage-access-rules/${item.id}`
        );
        this.$message.success(
          this.$t("safemanager.access_rules.delete_success_tips")
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  batchDelete() {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("safemanager.access_rules.delete_tips", {
            num: this.selectDatas.length
          }),
          this.$t("vdcontainer.hint"),
          {
            confirmButtonText: this.$t("vdcontainer.determine"),
            cancelButtonText: this.$t("vdcontainer.cancel"),
            type: "warning"
          }
        );
        let ids = [];
        for (let item of this.selectDatas) {
          ids.push(item.id);
        }
        yield API.delete(`api://base.auth/api/v1/webpage-access-rules`, {
          data: {
            ids
          }
        });
        this.$message.success(
          this.$t("safemanager.access_rules.delete_success_tips")
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleOffRule(item) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v1/webpage-access-rules/${item.id}`, {
          model: "access.rule.status",
          status: "disable"
        });
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleOpenRule(item) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v1/webpage-access-rules/${item.id}`, {
          model: "access.rule.status",
          status: "enable"
        });
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
};
__decorateClass([
  Ref("grid-table")
], AccessRules.prototype, "_grid_table", 2);
AccessRules = __decorateClass([
  Component({
    components: {
      UiGrid,
      BatchOperate
    }
  })
], AccessRules);
export {
  AccessRules as default
};
